import { Base } from "../../framework/base";
import { ListItems } from "../../framework/listItems";
import { IModifyUser, ModifyUser } from "./modifyUser";

export interface IModifyUserItems extends ListItems<IModifyUser> {
}

export class ModifyUserItems extends ListItems<ModifyUser> implements IModifyUserItems {
    constructor();
    constructor(obj: IModifyUserItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, ModifyUser);
    }
}